import { FC } from "react";

interface SearchHairlineProps {}

export const SearchHairline: FC<SearchHairlineProps> = () => {
  return <hr className={"text-ui-grey-300 my-32"} />;
};
